import React, {Component} from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import {dracula} from 'react-syntax-highlighter/dist/esm/styles/prism';
//import flag from '../img/a.png';
class Usage extends Component {
    

    render() {

            return (

<section id='usage' className="py-5 install_section">
    <div className="container">
        <div className="row">
            <div className="col-md-8 mx-auto">
                <h2 className="text-center text-md-left">Install package</h2>
                <div className="mx-auto">
                <div className="code-window">
                    
<SyntaxHighlighter language="javascript" style={dracula} showLineNumbers="true" wrapLongLines="true">
      {'npm install --save react-ig-feed'}
    </SyntaxHighlighter>                </div>
            </div>
            </div>
        </div>
    
        <div className="row">
            <div className="col-md-8 mx-auto">
                <h2 className="text-center text-md-left">Usage the react component</h2>
                <div className="mx-auto">
                <div className="code-window">
                
                    
                    <SyntaxHighlighter language="javascript" style={dracula} showLineNumbers="true" wrapLongLines="true">
      {`import InstagramFeed  from 'react-ig-feed'
import 'react-ig-feed/dist/index.css'

const App = () => {
  return (
     <InstagramFeed token={your_token}  counter="6"/>
  );
};`}
    </SyntaxHighlighter> 
                </div>
            </div>
            </div>
        </div>
        </div>
</section>





                

            );

        }

    }


export default Usage;
